import React from 'react';
import { styled, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { imgLinks } from '../../shared';
import { MIN_WIDTH_MD } from '../../theme/breakpoints';

const StyledIcon = styled('img')`
  padding: 0;
  width: 2.5rem;
  height: 2.5rem;

  @media (min-width: ${MIN_WIDTH_MD}) {
    width: 3.5rem;
    height: 3.5rem;
  }
`;

const StyledIconContainer = styled('div')`
  margin-right: 0.625rem;
  width: 1.25rem;
  height: 1.25rem;
  align-self: center;
`;

export default function Icon({ icon, alt, ...rest }) {
  return <StyledIcon src={imgLinks[`${icon}`]} alt={alt || ''} {...rest} />;
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export function WrongListItemIcon() {
  return (
    <StyledIconContainer>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_758_14976)">
          <path
            d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
            fill="#003264"
          />
          <rect
            x="4"
            y="5.04346"
            width="1.50943"
            height="8.75472"
            rx="0.754717"
            transform="rotate(-43.7308 4 5.04346)"
            fill="white"
          />
          <rect
            width="1.51519"
            height="8.75472"
            rx="0.757594"
            transform="matrix(-0.722596 -0.691271 -0.691271 0.722596 11.3701 5.27417)"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_758_14976">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </StyledIconContainer>
  );
}

export function RightListItemIconPetolo() {
  return (
    <StyledIconContainer>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.83639 10.3598L2.91909 6.95314C2.57986 6.65938 2.13028 6.50422 1.66924 6.52179C1.2082 6.53935 0.773482 6.72822 0.460707 7.04682C0.147932 7.36543 -0.0172742 7.78769 0.00143178 8.2207C0.0201378 8.65371 0.221224 9.06201 0.560453 9.35577L5.90039 13.9926C6.07973 14.1485 6.29209 14.2671 6.5236 14.3406C6.7551 14.4141 7.00052 14.4409 7.2438 14.4192C7.48708 14.3975 7.72274 14.3278 7.93537 14.2146C8.14799 14.1015 8.33278 13.9475 8.47766 13.7626L15.6412 4.62433C15.7818 4.4522 15.8844 4.25546 15.9431 4.04564C16.0017 3.83581 16.0152 3.6171 15.9828 3.40232C15.9504 3.18753 15.8726 2.98097 15.7542 2.79474C15.6357 2.6085 15.4789 2.44633 15.2929 2.3177C15.1069 2.18907 14.8955 2.09658 14.671 2.04563C14.4464 1.99468 14.2134 1.9863 13.9853 2.02098C13.7573 2.05566 13.539 2.1327 13.3431 2.24759C13.1471 2.36249 12.9776 2.51293 12.8443 2.69011L6.83639 10.3598Z"
          fill="#FFA445"
        />
      </svg>
    </StyledIconContainer>
  );
}

export function RightListItemIconDentolo() {
  return (
    <StyledIconContainer>
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7139 11.8022C16.7139 15.9444 13.356 19.3022 9.21387 19.3022C5.07173 19.3022 1.71387 15.9444 1.71387 11.8022C1.71387 7.66011 5.07173 4.30225 9.21387 4.30225C13.356 4.30225 16.7139 7.66011 16.7139 11.8022Z"
          fill="#32FF96"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1991 2.13022C21.7288 2.67435 21.7171 3.54487 21.173 4.07459L9.35324 15.5813L4.68344 10.2956C4.18064 9.72655 4.2344 8.8576 4.80349 8.35481C5.37259 7.85202 6.24153 7.90577 6.74433 8.47487L9.5031 11.5974L19.2547 2.10412C19.7989 1.57441 20.6694 1.58609 21.1991 2.13022Z"
          fill="#003264"
        />
      </svg>
    </StyledIconContainer>
  );
}

export function RightCaretIcon() {
  const theme = useTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_1933_1535)">
        <path
          d="M3.88591 15.6685C3.77879 15.5623 3.69377 15.4359 3.63574 15.2966C3.57772 15.1573 3.54785 15.0079 3.54785 14.8571C3.54785 14.7062 3.57772 14.5568 3.63574 14.4176C3.69377 14.2783 3.77879 14.1519 3.88591 14.0456L9.72591 8.20564C9.75356 8.17899 9.77555 8.14704 9.79058 8.11169C9.8056 8.07635 9.81334 8.03833 9.81334 7.99993C9.81334 7.96152 9.8056 7.92351 9.79058 7.88817C9.77555 7.85282 9.75356 7.82087 9.72591 7.79422L3.88591 1.95422C3.77879 1.84797 3.69377 1.72157 3.63574 1.5823C3.57772 1.44304 3.54785 1.29366 3.54785 1.14279C3.54785 0.991916 3.57772 0.842538 3.63574 0.70327C3.69377 0.564003 3.77879 0.437601 3.88591 0.331358C4.10004 0.1185 4.38969 -0.000976562 4.69162 -0.000976562C4.99355 -0.000976562 5.28321 0.1185 5.49734 0.331358L11.9545 6.7885C12.2727 7.11139 12.4512 7.54655 12.4512 7.99993C12.4512 8.4533 12.2727 8.88847 11.9545 9.21136L5.49734 15.6685C5.28321 15.8814 4.99355 16.0008 4.69162 16.0008C4.38969 16.0008 4.10004 15.8814 3.88591 15.6685Z"
          fill={theme.palette.text.button}
        />
      </g>
      <defs>
        <clipPath id="clip0_1933_1535">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DocumentIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.08338 1.171C4.92204 1.171 4.68666 1.37366 4.5701 1.49153C4.45325 1.60967 4.22788 1.90225 4.22788 2.07277V8.21236C4.22788 8.61588 4.00858 9.01734 3.60506 9.01734C3.20155 9.01734 3.00391 8.63757 3.00391 8.23406V2.09446C3.00391 1.54157 3.22106 1.0097 3.61012 0.616316C3.99947 0.222642 4.52926 0 5.08338 0H14.6413C15.195 0.00011973 15.7246 0.222566 16.1138 0.615839L21.3943 6.37497C21.7829 6.76821 22 7.29984 22.0002 7.85233V21.2189C22.0002 22.0259 21.346 22.6801 20.5389 22.6801H10.3102C9.90665 22.6801 9.57954 22.353 9.57954 21.9495C9.57954 21.546 9.83662 21.2525 10.2401 21.2525H19.6913C20.2415 21.2525 20.6884 20.808 20.6913 20.2577L20.7561 7.85233C20.5724 7.68206 20.6576 7.5481 20.7561 7.40251M20.7561 7.40251L14.8602 1.381C14.7437 1.26341 14.8024 1.17108 14.6413 1.171H5.08338"
        fill="#003264"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3843 -0.000244141C14.8791 -0.000244141 14.8603 0.400911 14.8603 0.895761V6.27179C14.8603 6.81067 14.9075 6.92461 14.9915 7.00858C15.0755 7.09257 15.1895 7.1398 15.3083 7.1398H21.1043C21.5992 7.1398 22.0003 7.12095 22.0003 7.6158C22.0003 8.11065 21.5992 8.51181 21.1043 8.51181H15.7283C15.1343 8.51181 14.5644 8.27583 14.1443 7.85572C13.7242 7.4356 13.4883 6.86582 13.4883 6.27179V0.895761C13.4883 0.400911 13.8894 -0.000244141 14.3843 -0.000244141Z"
        fill="#003264"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.14018 12.0727C2.91894 12.1623 2.71845 12.2935 2.55033 12.4587C2.3822 12.624 2.24982 12.8199 2.16093 13.0351C2.07202 13.2503 2.02839 13.4804 2.03256 13.712L2.03263 13.7207L2.03225 20.0765C2.03225 20.0765 2.03225 20.0765 2.03225 20.0765C2.03227 20.8367 2.34494 21.5658 2.90148 22.1034C3.45808 22.641 4.21293 22.943 4.99998 22.9429C5.78709 22.9429 6.54198 22.641 7.09853 22.1034C7.65508 21.5659 7.96775 20.8368 7.96775 20.0765L7.96739 12.3375C7.96738 12.0622 8.19845 11.839 8.4835 11.839C8.76855 11.839 8.99963 12.0622 8.99965 12.3375L9 20.0765C9 21.1011 8.57859 22.0839 7.82844 22.8084C7.07829 23.5329 6.06086 23.9399 4.99999 23.9399C3.93915 23.94 2.92174 23.5329 2.17157 22.8084C1.42143 22.0838 1.00001 21.1012 1 20.0765L1.00038 13.7248C0.994483 13.3624 1.06304 13.0024 1.20219 12.6656M3.14018 12.0727C3.36136 11.9831 3.59884 11.937 3.83878 11.9369C4.0786 11.937 4.31605 11.9831 4.53729 12.0727C4.7585 12.1623 4.95902 12.2936 5.12711 12.4588C5.29526 12.624 5.42763 12.8199 5.51649 13.0351C5.60539 13.2502 5.64906 13.4804 5.64489 13.712L5.64481 13.7208L5.64662 20.0731C5.64275 20.2351 5.57367 20.3893 5.45392 20.503C5.33333 20.6175 5.17094 20.6817 5.00174 20.6818C4.83257 20.6818 4.67016 20.6176 4.54951 20.5031C4.42975 20.3895 4.36062 20.2353 4.35666 20.0732L4.35558 13.721C4.35553 13.4457 4.12442 13.2225 3.83937 13.2225C3.55432 13.2226 3.32328 13.4458 3.32333 13.7211L3.32441 20.0784L3.32449 20.0871C3.33224 20.5118 3.5123 20.9166 3.82608 21.2143C4.13982 21.512 4.56208 21.6788 5.0019 21.6788C5.44169 21.6787 5.86394 21.5118 6.17761 21.214C6.4912 20.9162 6.67126 20.5113 6.6788 20.0865L6.67887 20.0778L6.67707 13.7248C6.68296 13.3623 6.61438 13.0023 6.47527 12.6657C6.33558 12.3274 6.12753 12.0196 5.86335 11.7599C5.59912 11.5002 5.28401 11.294 4.93648 11.1533C4.58889 11.0125 4.21569 10.9399 3.83874 10.9399C3.46183 10.94 3.08864 11.0125 2.74103 11.1532C2.39341 11.294 2.07831 11.5002 1.8141 11.7599C1.54991 12.0196 1.34188 12.3275 1.20219 12.6656"
        fill="#003264"
      />
    </svg>
  );
}

export function OpenLinkIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6303 0C10.1529 0 9.76236 0.385427 9.76236 0.865227C9.76236 1.34503 10.1529 1.73045 10.6303 1.73045H12.8968L7.32019 6.87144C6.96777 7.19632 6.94672 7.74488 7.27367 8.09563C7.59953 8.4452 8.14758 8.46569 8.49882 8.14189L14.2641 2.82702V5.53883C14.2641 6.01863 14.6546 6.40406 15.132 6.40406C15.6094 6.40406 16 6.01863 16 5.53883V1.45558C16 0.649736 15.3437 0 14.5384 0H10.6303ZM2.81763 2.34718C1.25384 2.34718 0 3.64061 0 5.21886V13.5531C0 15.1313 1.25384 16.4248 2.81763 16.4248H11.4199C12.9837 16.4248 14.2376 15.1313 14.2376 13.5531V8.29383C14.2376 7.83006 13.8676 7.44009 13.3942 7.44009C12.9208 7.44009 12.5509 7.83006 12.5509 8.29383V13.5531C12.5509 14.2038 12.0369 14.7173 11.4199 14.7173H2.81763C2.20068 14.7173 1.68668 14.2038 1.68668 13.5531V5.21886C1.68668 4.56814 2.20068 4.05464 2.81763 4.05464H8.22344C8.69686 4.05464 9.06678 3.66468 9.06678 3.20091C9.06678 2.73715 8.69686 2.34718 8.22344 2.34718H2.81763Z"
        fill="#003264"
      />
    </svg>
  );
}

export function OutlinedCheckIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 30.5C24.0081 30.5 30.5 24.0081 30.5 16C30.5 7.99187 24.0081 1.5 16 1.5C7.99187 1.5 1.5 7.99187 1.5 16C1.5 24.0081 7.99187 30.5 16 30.5Z"
        stroke="#003264"
        strokeWidth="2"
      />
      <path
        d="M9 16.6566L13.8485 21.1818L23.5455 11"
        stroke="#003264"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TipIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5641 1.30617C13.5641 0.302181 12.4772 -0.325303 11.6077 0.176664C11.2042 0.409664 10.9556 0.840219 10.9556 1.30617V2.87128C10.9556 3.87526 12.0425 4.5028 12.912 4.00078C13.3155 3.76778 13.5641 3.33723 13.5641 2.87128V1.30617ZM0 12.2618C0 11.5415 0.58396 10.9576 1.30423 10.9576H2.86934C3.87332 10.9576 4.50086 12.0445 3.99879 12.914C3.76579 13.3175 3.33529 13.5661 2.86934 13.5661H1.30423C0.58396 13.566 0 12.9821 0 12.2618ZM20.3462 12.2618C20.3462 11.5415 20.9301 10.9576 21.6504 10.9576H23.2155C24.2195 10.9576 24.847 12.0445 24.345 12.914C24.112 13.3175 23.6815 13.5661 23.2155 13.5661H21.6504C20.9301 13.5661 20.3462 12.9821 20.3462 12.2618ZM3.59086 3.5928C4.10012 3.08364 4.92573 3.08364 5.43505 3.5928L6.54209 4.69931C7.25209 5.40936 6.92724 6.62175 5.95735 6.88164C5.50719 7.00226 5.02686 6.87356 4.69737 6.54403L3.59086 5.43751C3.08133 4.92814 3.08133 4.10217 3.59086 3.5928ZM19.0847 3.5928C19.8069 2.89531 21.0133 3.24121 21.2562 4.21538C21.3651 4.65178 21.2414 5.11345 20.9289 5.43699L19.8229 6.54403C19.1129 7.25408 17.9004 6.92918 17.6406 5.95929C17.52 5.50913 17.6487 5.02885 17.9782 4.69931L19.0842 3.5928H19.0847ZM19.3028 12.7835C19.3028 8.89373 16.1496 5.74062 12.2599 5.74062C8.37012 5.74062 5.21696 8.89373 5.21696 12.7835C5.21696 14.7164 5.99535 16.4667 7.25573 17.7397H17.264C18.5722 16.4222 19.3053 14.6402 19.3028 12.7835ZM12.2599 10.4359C13.5564 10.4359 14.6075 11.487 14.6075 12.7835C14.609 13.3859 15.2621 13.7607 15.7831 13.4582C16.0236 13.3185 16.1719 13.0617 16.1726 12.7835C16.1726 10.6226 14.4208 8.8708 12.2599 8.8708C11.6575 8.87236 11.2826 9.52544 11.5852 10.0464C11.7249 10.2869 11.9817 10.4352 12.2599 10.4359ZM17.0125 19.3047H7.50719C7.50406 19.3502 7.5025 19.3958 7.5025 19.4414C7.5025 19.6501 7.53747 19.8525 7.60841 20.0434C7.6142 20.0832 7.61644 20.1233 7.61519 20.1634C7.61284 20.2425 7.60179 20.3211 7.58235 20.3977C7.52772 20.6045 7.50088 20.8176 7.5025 21.0315C7.5025 21.2647 7.53122 21.476 7.58235 21.6654C7.71277 22.1438 8.04976 22.4338 8.38263 22.5883C8.69616 22.7338 9.03315 22.7761 9.29978 22.7818C9.38114 22.7839 9.4709 22.786 9.57051 22.7876C9.77714 23.3411 10.2591 23.8012 10.9113 23.8988C11.2567 23.951 11.7251 24 12.2599 24C12.7941 24 13.2631 23.9504 13.6079 23.8988C14.2601 23.8012 14.7426 23.3411 14.9492 22.7876L15.22 22.7824C15.4866 22.7756 15.8236 22.7338 16.1371 22.5883C16.4705 22.4338 16.8075 22.1438 16.9374 21.6649C16.989 21.476 17.0172 21.2647 17.0172 21.031C17.0172 20.7978 16.989 20.5865 16.9374 20.3977C16.9178 20.3209 16.9068 20.2421 16.9045 20.1629C16.9033 20.1295 16.9045 20.096 16.9082 20.0628L16.9092 20.0565L16.9103 20.0476L16.9113 20.0434C16.9986 19.8076 17.033 19.5554 17.012 19.3047H17.0125Z"
        fill="#003264"
      />
    </svg>
  );
}
